module.exports = __webpack_public_path__ + "img/5.03b03bd6.png";